/**
 * @file getElementPosition
 * @author yuzong(yuzong@tencent.com)
 */
import { getDefaultElementBoundary, isClient } from '@tencent/glue-util-boundary';
import { swap } from './swap';
/**
 * 获取元素位置
 *
 * @param element 要获取的元素
 */

export function getElementBoundary(element) {
  if (!isClient()) {
    return getDefaultElementBoundary();
  }

  var style = getComputedStyle(element);

  var getPosition = function getPosition() {
    var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height,
        top = _element$getBoundingC.top,
        left = _element$getBoundingC.left,
        right = _element$getBoundingC.right,
        bottom = _element$getBoundingC.bottom;

    return {
      width: width,
      height: height,
      top: top,
      left: left,
      right: right,
      bottom: bottom
    };
  };

  if (style.display !== 'none') {
    return getPosition();
  }

  return swap(element, {
    display: 'block'
  }, getPosition);
}